import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatButton } from '@angular/material/button';

import { TranslatePipe } from '@ngx-translate/core';
@Component({
    selector: 'app-auction-item-status',
        standalone: true,
imports: [MatButton, NgClass, TranslatePipe],
    templateUrl: './auction-item-status.component.html',
    styleUrl: './auction-item-status.component.scss'
})
export class AuctionItemStatusComponent {
  @Input() isRna!: boolean;
  @Input() isWinner!: boolean;
  @Input() isSold!: boolean;
  @Input() isUnSold!: boolean;
  @Input() isReserved!: boolean;
  @Input() isPS!: boolean; // Post Sale - offline sold horse
  @Input() isWithdrawn: boolean = false;
}
